export default "__VITE_ASSET__CbgHcGG7__"